module.exports = __webpack_public_path__ + "img/Johnston_Twisp_4328.aa8228d7.jpg";